import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./store";

interface LicenseState {
  subscriptionSummary: any | null;
}

const initialState: LicenseState = {
  subscriptionSummary: null,
};

const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
    setSubscriptionSummary: (state, action: PayloadAction<any>) => {
      state.subscriptionSummary = action.payload;
    },
    clearSubscriptionSummary: (state) => {
      state.subscriptionSummary = null;
    },
  },
});

export const { setSubscriptionSummary, clearSubscriptionSummary } =
  licenseSlice.actions;

// Selectors
export const selectSubscriptionSummary = (state: RootState) =>
  state.license.subscriptionSummary;

export default licenseSlice.reducer;
